import { mirrorX, setDefaultStyle } from "apparatus/draw";
import { DEFAULT_LIQUID_DATA, P, Segments } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
export class Crucible {
    render(appearance) {
        let width = appearance.diameter;
        let height = appearance.height;
        let graphic = new Path(Segments([[0, 0]], [[width / 5, height], [-width / 5, 0]], [[width / 2, height]]));
        mirrorX(graphic, width / 2);
        let liquidMask = graphic.clone();
        setDefaultStyle(graphic);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            liquidMask: liquidMask,
            snapping: graphic.placeable()
        };
    }
}
Crucible.properties = {
    label: "Crucible",
    canContainLiquids: true,
    defaultAppearance: {
        diameter: 39, height: 43
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 25, max: 70,
        },
        {
            spec: "slider", key: "height", label: "Height",
            min: 35, max: 70,
        }
    ],
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { amountRatio: 0.3, color: "#aaaaaa" })
};
export class CrucileCover {
    render(appearance) {
        var width = appearance.diameter;
        var cover = new Path(Segments([[-5, 5], undefined, [0, -3]], [[0, 0]], [[width / 2, -5], [-width / 4, 0]]));
        mirrorX(cover, width / 2);
        let handle = Shape.Circle(P(width / 2, -10), 5);
        let graphic = new Group([cover, handle]);
        setDefaultStyle(graphic);
        return { graphic: graphic, hitShape: graphic.bounds.toShape() };
    }
}
CrucileCover.properties = {
    label: "Crucible Cover",
    defaultAppearance: {
        diameter: Crucible.properties.defaultAppearance.diameter
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 25, max: 70,
        },
    ],
};
